<template lang="pug">
  #popup-scan.popup__main
    .popup__header
      a(href="#" @click.prevent="closePopup").popup__close
    .popup__content
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'PopupScan',
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(['popup']),
  },
  methods: {
    ...mapActions(['closePopup']),
  },
  mounted() {
  },
  components: {
  }
}
</script>

<style lang="scss">

#popup-scan {

  width: 100%;
  height: 100vh;
  margin: 0 auto;
  background: url('~@/assets/images/common/popup-scan.png') no-repeat center 0 / contain;

  .popup__close {
    position: absolute;
    top: vhX(40);
    right: vhX(40);
    width: vhX(75);
    height: vhX(75);
    background: url('~@/assets/images/common/popup-close.png') no-repeat 0 0 / contain;
  }

}

</style>
